import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, Alert, Button } from 'react-bootstrap';
import TrailReviews from '../Trail/components/TrailReviews';
import './TrailReviews.css';

const TrailReviewsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <Container className="py-4">
        <Alert variant="danger">
          Invalid trail ID. Please select a valid trail.
        </Alert>
      </Container>
    );
  }

  return (
    <Container fluid className="admin-page-container py-4">
      <div className="trail-reviews-page">
        <div className="page-header mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1>Trail Reviews Management</h1>
              <p className="text-muted">
                Manage reviews for Trail ID: {id}
              </p>
            </div>
            <Button 
              variant="outline-secondary" 
              onClick={() => navigate('/trails')}
              className="d-flex align-items-center gap-2"
            >
              <i className="fas fa-arrow-left"></i>
              Back to Trails
            </Button>
          </div>
        </div>

        <Card>
          <Card.Body>
            <TrailReviews trailId={id} />
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default TrailReviewsPage;